import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from "@angular/forms";
import {DelayBlockModel, DelayBlockModelInterface} from "@app/workflow-common/services/models/DelayBlockModel";
import {EmailBlockModel} from "@app/workflow-common/services/models/EmailBlockModel";


@Component({
  selector: 'app-delay-block-widget',
  templateUrl: './delay-block-widget.component.html',
  styles: []
})
export class DelayBlockWidgetComponent implements OnInit {

    @Input() workflowType: string;
    @Input() blockObject;
    @Input() dagSourceModel: DagSourceModel;
    @Input() objectName: string;
    @Input() isConditional:boolean = false;
    @Input() conditionalColName: string = '';
    @Output() close:EventEmitter<{}> = new EventEmitter<{}>();

    form: FormGroup;
    delayBlockData:{} = {};
    showDeleteBtn: boolean = false;
    inputModel: DelayBlockModelInterface = undefined;
    units:string[] = ['Minutes','Hours', 'Days', 'Months'];
    minutesInterval: any[] = Array.from(Array(60).keys());
    hoursInterval: any[] = Array.from(Array(24).keys());
    daysInterval: any[] = Array.from(Array(31).keys());
    monthsInterval: any[] = Array.from(Array(13).keys());
    isFormSubmitted: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit() {
        this.delayBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
        const blockObject = {...this.blockObject};
        const modelData = blockObject['model'] ? blockObject['model'] : undefined;
        if(modelData) {
            this.showDeleteBtn=true;
        }
        this.inputModel = new DelayBlockModel(modelData);

        const formGroupConfig = {
            interval: new FormControl(this.inputModel.interval, [Validators.required, this.notAllowed()]),
            type: new FormControl(this.inputModel.type),
            unit: new FormControl(this.inputModel.unit, [Validators.required]),
        };
        if(this.isConditional) {
            formGroupConfig['condition'] = this.formBuilder.group({});
        }
        this.form = this.formBuilder.group(formGroupConfig);
    }

    onChangeUnit(event:any) {
        if( (this.form.get('unit').value == 'Months' && this.form.get('interval').value > 12)
            || (this.form.get('unit').value == 'Days' && this.form.get('interval').value > 30)
            || (this.form.get('unit').value == 'Hours' && this.form.get('interval').value > 23)){
            this.form.get('interval').setValue(0);
        }
    }

    notAllowed(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const forbidden = control.value == 0;
            return forbidden ? {notAllowed: {value: control.value}} : null;
        };
    }

    save() {
        const blockObject = {...this.blockObject};

        blockObject.model = new DelayBlockModel(this.form.value);
        const { condition } = this.form.value;
        if(this.isConditional) {
            blockObject['condition'] = condition;
            blockObject['isConditional'] = true;
        }
        console.log('xzxc', blockObject)
        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        })
    }

    closeModal() {
        this.close.emit({
            action: 'close',
            data: null
        });
    }

    remove() {
        const blockObject = {...this.blockObject};
        blockObject.model = this.inputModel;
        this.close.emit({
            action: 'remove_block',
            data: blockObject
        });
    }

}
